import { AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery } from '@festina/moneyin-general-types/moneyin/hooks/AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery'

export const useFetchAnnotationCommands =
  AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery.useSuspenseQuery
